import { render, staticRenderFns } from "./ErrorMessageListComponent.vue?vue&type=template&id=689e0852&"
import script from "./ErrorMessageListComponent.vue?vue&type=script&lang=js&"
export * from "./ErrorMessageListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports